<template>
  <div v-if="isLoading">
    <label class="label text-sm mb-1">{{ $attrs.label }}</label>
    <div class="skeleton h-10 w-full" />
  </div>
  <form-autocomplete
    v-else
    v-bind="$attrs"
    :options="countryOptions"
    :filter="filterCountries"
  >
    <template
      v-for="(_, name) in $slots"
      :key="name"
      #[name]="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData"
      />
    </template>
  </form-autocomplete>
</template>

<script setup>
import { CountryNamesByCode } from '@/constants/countries.js';

defineOptions({
  name: 'FormCountrySelect',
});

defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const countryOptions = Object.entries(CountryNamesByCode).map(([value, label]) => ({
  label: `${label} - ${value}`,
  value,
}));

function filterCountries(option, search) {
  const term = search.toLowerCase();

  return option.label.toLowerCase().includes(term) || option.value.toLowerCase().includes(term);
}
</script>
